import script from "./SongCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./SongCanvas.vue?vue&type=script&setup=true&lang=js"

import "./SongCanvas.vue?vue&type=style&index=0&id=58f29aeb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58f29aeb"]])

export default __exports__